<template>
  <div>
    <SearchBox />

    <div class="container">
      <AisStateResults>
        <template v-slot="{ state: { query }, results: { nbHits } }">
          <div>
            <div class="row">
              <div v-show="nbHits > 0" class="col-xl-3 col-lg-4 col-md-12 mb-2 order-lg-2">

                <div class="d-none d-lg-block">
                  <SearchFilter class="d-none" attribute="super_category" default_option="All supercategories" />
                  <div class="mb-4 d-none">
                    <div class="mb-1 fw-bold">Filter Locations</div>
                    <SearchFilter class="my-1" attribute="region" default_option="All of New Zealand" />
                    <SearchFilter class="my-1" attribute="district" default_option="All districts" parent_filter="region" />
                  </div>
                  <div class="mb-4">
                    <div class="mb-1 fw-bold">Filter Categories</div>
                    <SearchFilter class="my-1" attribute="category" default_option="All categories" />
                    <SearchFilter class="my-1" attribute="subcategories" default_option="All subcategories" parent_filter="category" />
                  </div>
                  <div class="mb-4">
                    <SearchToggleGroup class="my-1" attribute="tags" label="Featured by SuperGold" />
                  </div>
                  <div class="mb-4">
                    <SearchToggleGroup class="my-1" attribute="availability" label="Availability" />
                  </div>
                </div>

                <div class="accordion my-3 d-lg-none" id="show-filters">
                  <div class="accordion-item">
                    <h2 class="accordion-header" id="show-filters-header">
                      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#search-filters" aria-expanded="true" aria-controls="search-filters">
                        Search filters
                      </button>
                    </h2>
                    <div id="search-filters" class="accordion-collapse collapse" aria-labelledby="show-filters-header" data-bs-parent="#show-filters">
                      <div class="accordion-body">
                        <SearchFilter class="d-none" attribute="super_category" default_option="All supercategories" />
                        <div class="mb-4 d-none">
                          <div class="mb-1 fw-bold">Filter Locations</div>
                          <SearchFilter class="my-1" attribute="region" default_option="All of New Zealand" />
                          <SearchFilter class="my-1" attribute="district" default_option="All districts" parent_filter="region" />
                        </div>
                        <div class="mb-4">
                          <div class="mb-1 fw-bold">Filter Categories</div>
                          <SearchFilter class="my-1" attribute="category" default_option="All categories" />
                          <SearchFilter class="my-1" attribute="subcategories" default_option="All subcategories" parent_filter="category" />
                        </div>
                        <div class="mb-4">
                          <SearchToggleGroup class="my-1" attribute="tags" label="Featured by SuperGold" />
                        </div>
                        <div class="mb-4">
                          <SearchToggleGroup class="my-1" attribute="availability" label="Availability" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <SearchFilterClear />
              </div>

              <div class="col-12 order-lg-1">
                <SearchResultsCount />
              </div>

              <div class="col-xl-9 col-lg-8 col-md-12 my-1 order-lg-3">
                <SearchResults />
              </div>
            </div>
            <SearchPagination v-show="nbHits > 0"/>
          </div>
        </template>
      </AisStateResults>
    </div>
  </div>
</template>

<script>
import { AisStateResults } from 'vue-instantsearch/vue3/es';
import SearchBox from './components/search_box.vue';
import SearchFilter from './components/search_filter.vue';
import SearchToggleGroup from './components/search_toggle_group.vue';
import SearchFilterClear from './components/search_filter_clear.vue';
import SearchResults from './components/search_results.vue';
import SearchPagination from './components/search_pagination.vue';
import SearchResultsCount from './components/search_result_count.vue';

export default {
  name: 'SearchResultsPage',
  components: {
    SearchBox,
    SearchFilter,
    SearchToggleGroup,
    SearchFilterClear,
    SearchResults,
    SearchPagination,
    SearchResultsCount,
    AisStateResults,
  },
};
</script>
